export const INVENTORY_MANAGEMENT_PRODUCT_HEADING = 'Manage Products';
export const INVENTORY_MANAGEMENT_PRODUCT_SUBHEADING = 'Create, Edit and Remove your Products';
export const INVENTORY_MANAGEMENT_PRODUCT_CREATE_BUTTON_LABEL = 'Create New Product';
export const INVENTORY_MANAGEMENT_PRODUCT_DATA_TABLE_TITLE = 'Current Products';
export const INVENTORY_MANAGEMENT_NO_PRODUCTS = 'You currently do not have any products.';

export const INVENTORY_MANAGEMENT_ITEM_HEADING = 'Manage Items';
export const INVENTORY_MANAGEMENT_ITEM_SUBHEADING = 'Create, Edit and Remove your Items';
export const INVENTORY_MANAGEMENT_ITEM_CREATE_BUTTON_LABEL = 'Create New Item';
export const INVENTORY_MANAGEMENT_ITEM_DATA_TABLE_TITLE = 'Current Items';
export const INVENTORY_MANAGEMENT_NO_ITEMS = 'You currently do not have any items.';

export const INVENTORY_MANAGEMENT_INV_HEADING = 'Manage User Inventory';
export const INVENTORY_MANAGEMENT_INV_SUBHEADING = "Create, Edit and Remove user's inventory items";
export const INVENTORY_MANAGEMENT_INV_CREATE_BUTTON_LABEL = 'Create New Inventory Item';
export const INVENTORY_MANAGEMENT_INV_DATA_TABLE_TITLE = 'Current Inventory Items';
export const INVENTORY_MANAGEMENT_NO_INVS =
    'This user currently does not have any items in their inventory.';

export const INVENTORY_MANAGEMENT_REC_HEADING = 'View Inventory Records';
export const INVENTORY_MANAGEMENT_REC_SUBHEADING = 'View records for a specific user.';
export const INVENTORY_MANAGEMENT_REC_DATA_TABLE_TITLE = 'Current Records';
export const INVENTORY_MANAGEMENT_NO_RECS = 'There are no records for this user.';
